
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Eliminate Safety Hazards',
      description: 'Tree stumps are tripping hazards that can cause serious injuries to family members, guests, and pets. Professional stump grinding removes these dangers completely, creating a safe outdoor environment for everyone.'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Boost Property Value',
      description: 'Unsightly stumps detract from curb appeal and can reduce property values by thousands of dollars. Removing stumps instantly improves your landscape aesthetics and makes your property more attractive to potential buyers.'
    },
    {
      icon: 'ri-bug-line',
      title: 'Prevent Pest Infestations',
      description: 'Decaying stumps attract termites, carpenter ants, beetles, and other wood-boring insects that can spread to your home. Stump grinding eliminates this breeding ground before pests become a costly problem.'
    },
    {
      icon: 'ri-plant-line',
      title: 'Stop Unwanted Regrowth',
      description: 'Left alone, tree stumps often sprout new shoots that require constant maintenance. Professional grinding removes the root system below ground level, preventing regrowth and saving you ongoing yard work.'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Reclaim Usable Space',
      description: 'Transform unusable areas into functional outdoor living spaces. Once the stump is removed, you can plant new gardens, install patios, expand play areas, or simply enjoy more open lawn space.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Easier Lawn Maintenance',
      description: 'Stumps make mowing difficult and can damage lawn equipment. Removing stumps allows for smooth, efficient mowing patterns and eliminates the frustration of navigating around obstacles in your yard.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Prevent Disease Spread',
      description: 'Diseased stumps can harbor fungi and pathogens that spread to healthy trees and plants in your landscape. Grinding removes the infected wood and protects the rest of your valuable trees.'
    },
    {
      icon: 'ri-timer-line',
      title: 'Fast & Efficient Process',
      description: 'Professional stump grinding is quick, typically taking just 30-60 minutes per stump. Our tracked equipment fits through 36-inch gates, minimizing disruption to your property and daily routine.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded-full mb-4">
            WHY CHOOSE STUMP GRINDING
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Benefits of Professional Stump Removal
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover why thousands of Atlanta homeowners trust professional stump grinding to protect their property, enhance their landscape, and improve their quality of life
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-2xl border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
